<!--
@Create By Tim For 19/08/16
@课件概述组件
-->
<template>
  <div class="CourseOverview">
    <!-- 富文本组件 -->
    <div class="ql-container ql-snow"><div class="ql-editor" v-html="overview"></div></div>
  </div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
export default {
  name: 'CourseOverview',
  props: ['overview'],
  mounted() {},
  data() {
    return {};
  },

  created() {},
  methods: {}
};
</script>

<style scoped>
.CourseOverview {
  background: #fff;
}
.CourseOverview p {
  font-size: 14px;
  color: #333;
}
.ql-container.ql-snow {
  height: 100%;
  border: 0px solid #ccc !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CourseInfo/CourseOverview.vue